<template>
  <div>
    <div class="SelTop">
      <!-- <div class="sel_left" @click.self="showPopup">
        <p>{{brandName==''?'全部品牌':brandName}}</p>
        <van-popup
          v-model="show"
          position="top"
          :style="{ width: '100%' ,height:'45%',background: 'linear-gradient(134deg, #CC4545 100%, #F4BA76 100%)'}"
         get-container="#app"
        >
          <div class="historySel">
            <van-divider
              content-position="left"
              :style="{ color: '#fff', borderColor: '#fff', padding: '0 16px' }"
            >历史选择</van-divider>
            <van-grid :gutter="18" :clickable="true" :border="false" :column-num="3">
              <van-grid-item
                v-for="value in historySel"
                :key="value"
                :text="value"
                @click="sendBrand(value)"
              />
            </van-grid>
          </div>
          <div class="allSel">
            <van-divider
              content-position="left"
              :style="{ color: '#fff', borderColor: '#fff', padding: '0 16px' }"
            >全部品牌</van-divider>

            <van-grid :gutter="18" :clickable="true" :border="false" :column-num="3">
              <van-grid-item
                v-for="value in allBrand"
                :key="value.brandCd"
                :text="value.brandCd"
                @click="selBrand(value.brandCd),sendBrand(value.brandCd)"
              />
            </van-grid>
          </div>
        </van-popup>
        <b></b>
      </div> -->
      <div class="showDate" v-show="showDate">
        <ul>
          <li>
            说明：每日更新截止前一日24点的交易数据，现更新至{{ TmallFsTime2 }}
          </li>
          <li>时间：工作日每日12点至14点为更新高峰，数据如有滞后请谅解</li>
          <!-- <li>维度：数据时间维度为{{ startTime }}~{{ endTime }}</li> -->
          <!-- <li>
            Vs·ly同期: 为{{ startTime }}至今销售额累加数对比{{ lyStarYear }}年{{
              lyStarMon
            }}月{{ lyStarDay }}日~{{ lyEndMon }}月{{ lyEndDay }}日同期销售额
          </li> -->
          <!-- <li>大贸旗舰店/跨境旗舰店数据更新到{{secondTime}}</li>
          <li>国内综合店/跨境旗舰店数据更新到{{secondTime}}</li>
          <li>Other EKA/天猫超市/京东/社交电商/淘宝分销部分更新到{{fouthTime}}</li>
          <li>销售额：5.25 - 5.31仅包含现货销售额；6.1一次性增加预售商品结清总额。</li> -->
          <!-- <li>{{lyStarYear}}年基数数据范围为{{lyStarMon}}月{{lyStarDay}}日~{{lyEndMon}}月{{lyEndDay}}(大贸旗舰店/跨境旗舰店/国内综合店取用生意参谋数据)</li> -->
        </ul>
      </div>

      <div class="sel_right" @click="showUpdata()">
        <p>更新时间说明</p>
        <b>!</b>
      </div>
    </div>
    <div class="brand_table">
      <PosTable :brandCd="brandName"></PosTable>
    </div>
  </div>
</template>
<script>
import PosTable from "@/components/Pos/table_list";

export default {
  data() {
    return {
      
      show: false,
      showDate: false,
      historySel: [],
      allBrand: [],
      historyBrand: [],
      brandName: "",
      firstTime: "",
      secondTime: "",
      fouthTime: "",
      allTime: "",
      TmallFsTime: "",
      TmallFsTime2: "",
      TmallFsTime3: "",
      startTime: "",
      endTime: "",
      lyStarYear: "",
      lyStarMon: "",
      lyStarDay: "",
      lyEndYear: "",
      lyEndMon: "",
      lyEndDay: "",
      upDataFlag:0,
      upDataTmallFlag:0
    };
  },
  components: {
    PosTable,
  },
  methods: {
   
    sendBrand(brand) {
      this.brandName = brand;
      this.show = false;
    },
    showPopup() {
      this.show = true;
    },
    showUpdata() {
      this.showDate = !this.showDate;
    },
    getHistoryBrand() {
      localStorage.getItem("historyBrand") == ""
        ? (this.historySel = ["暂无"])
        : (this.historySel = JSON.parse(localStorage.getItem("historyBrand")));
    },
    selBrand(text) {
      this.brandName = text;
      if (this.historyBrand.length <= 3) {
        this.historyBrand.unshift(text);
      } else {
        this.historyBrand.splice(2, 0, text);
      }
      let set = new Set(this.historyBrand); // set 自带去重
      localStorage.setItem("historyBrand", JSON.stringify(set));
      this.getHistoryBrand();
      this.show = false;
    },
    getAllBrand() {
      this.$addr
        .post(`Sales/getBrandList`)
        .then((res) => {
          this.allBrand = res.data.data;
          this.allBrand.unshift({ brandCd: "全部店铺" });
        })
        .catch((error) => {
          // Toast.fail("加载失败");
        });
    },
    getUpdateTime() {
      this.$addr.post("Sales/getUpdateDate").then((res) => {
        this.upDataFlag=res.data.data[0].updateFlag
        this.upDataTmallFlag=res.data.data[0].updateTmallFlag
        const startYear = res.data.data[0].startDate.substr(2, 2);
        const startMon = res.data.data[0].startDate.substr(4, 2);
        const startDay = res.data.data[0].startDate.substr(6, 2);
        const endMon = res.data.data[0].endDate.substr(4, 2);
        const endDay = res.data.data[0].endDate.substr(6, 2);
        this.startTime = `${startYear}年${startMon}月${startDay}日`;
        this.endTime = `${startYear}年${endMon}月${endDay}日`;

        this.lyStarYear = res.data.data[0].lyStartDate.substr(2, 2);
        this.lyStarMon = res.data.data[0].lyStartDate.substr(4, 2);
        this.lyStarDay = res.data.data[0].lyStartDate.substr(6, 2);
        this.lyEndMon = res.data.data[0].lyEndDate.substr(4, 2);
        this.lyEndDay = res.data.data[0].lyEndDate.substr(6, 2);

        var time3 = new Date(res.data.data[0].posSalesMaxDate.time);
        var y3 = time3.getFullYear();
        var m3 = (time3.getMonth() + 1).toString().padStart(2, 0);
        var d3 = time3.getDate().toString().padStart(2, 0);
        var sumTime3 = `${y3}${m3}${d3}`;
        this.allTime = `${y3}-${m3}-${d3}`;
        this.fouthTime = `${y3}年${m3}月${d3}日`;

        var time = new Date(res.data.data[0].cyberwayMaxDate.time);
        var y = time.getFullYear();
        var m = (time.getMonth() + 1).toString().padStart(2, 0);
        var d = time.getDate().toString().padStart(2, 0);
        var sumTime = `${y}${m}${d}`;

        var time2 = new Date(res.data.data[0].yuqiangMaxDate.time);
        var y2 = time2.getFullYear();
        var m2 = (time2.getMonth() + 1).toString().padStart(2, 0);
        var d2 = time2.getDate().toString().padStart(2, 0);
        var sumTime2 = `${y2}${m2}${d2}`;

        var time4 = new Date(res.data.data[0].versionUpdateDate.time);
        var y4 = time4.getFullYear();
        var m4 = (time4.getMonth() + 1).toString().padStart(2, 0);
        var d4 = time4.getDate().toString().padStart(2, 0);
        this.TmallFsTime = `${y4}-${m4}-${d4}`;
        this.TmallFsTime2 = `${y4}年${m4}月${d4}日`;
        this.TmallFsTime3 = `${y4}${m4}${d4}`;

        if (sumTime < res.data.data[0].posSalesMaxDate.promotionDate) {
          this.secondTime = `${y2}年${m2}月${d2}日`;
        } else {
          this.secondTime = `${y}年${m}月${d}日`;
        }
        const sendObj = {
          TmallFsTime: this.allTime,
          allTime: this.TmallFsTime,
          upDataFlag:this.upDataFlag,
          upDataTmallFlag:this.upDataTmallFlag
        };
        this.$emit("getTime", sendObj);
      });
    },
  },
  created() {
    this.getHistoryBrand();
    this.getAllBrand();
    this.getUpdateTime();
  },
};
</script>
<style scoped>

/deep/ .van-divider {
  font-family: "PingFangSC-Medium";
}
/deep/ .van-grid-item__text {
  color: rgb(200, 16, 46);
  font-size: 14px;
  word-wrap: break-word;
}
/deep/ .van-grid-item__content {
  background: #fff;
  border-radius: 20px;
}
.SelTop {
  position: relative;
  display: flex;
  padding: 0 16px;
  width: 100%;
  justify-content: space-between;
}
.SelTop .sel_left {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 300px;
  height: 21px;
  background: #ffffff;
  border: 1px solid #f1cbc9;
  box-shadow: 0 2px 5px 0 rgba(207, 111, 82, 0.3);
  border-radius: 42.5px;
}
.SelTop .sel_left p {
  padding-left: 14px;
  font-family: "PingFangSC-Medium";
  font-size: 12px;
  line-height: 21px;
  color: #d1534b;
}
.SelTop .sel_left b {
  display: inline-block;
  width: 8px;
  height: 11px;
  border-width: 6px;
  border-style: solid;
  border-color: transparent #d1534b transparent transparent;
  transform: scaleY(-1) rotate(180deg);
}
.SelTop .sel_right {
  position: relative;
  /* display: flex;
  align-items: center;
  justify-content: space-between; */
  width: 400px;
  height: 21px;
  background: rgba(152, 152, 152, 0.5);
  box-shadow: inset 0 0 5px 0 #9e9e9e;
  border-radius: 42.5px;
  margin-left: 10px;
}
.SelTop .sel_right p {
  float: left;
  font-family: "PingFangSC-Medium";
  font-size: 10px;
  line-height: 21px;
  color: #f9f9f9;
  padding-left: 13px;
}
.SelTop .sel_right b {
  float: right;
  margin-right: 5px;
  margin-top: 5px;
  text-align: center;
  line-height: 12px;
  font-size: 10px;
  background: #f9f9f9;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.brand_table {
  margin: 10px 0 40px;
}
.showDate {
  padding: 20px;
  font-family: "PingFangSC-Light";
  font-size: 10px;
  color: #191919;
  border: 1px solid black;
  z-index: 4;
  position: absolute;
  top: 30px;
  background: #fcfcfc;
  border-radius: 15px;
  min-height: 20px;
  width: 80%;
}
ul li {
  margin-bottom: 2px;
  font-size: 10px;
  color: #191919;
  width: 100%;
  height: 20px;
  white-space: nowrap; /* 强制不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  border-bottom: 1px solid rgba(157, 157, 157, 0.4);
  line-height: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/Pos/pos_FullStage.vue